<template>
  <div>
    <page-header>
      <div class="text-nowrap c-black ml-3 mr-3">
        <h4 class="form-check-label">Application Settings</h4>
      </div>

      <div class="badgebutton active text-nowrap c-white ml-4">
        <router-link class="ml-1 mt-3 mb-2" :to="{ name: 'Boards' }">
          <i class="far fa-caret-left"></i>
          Back to Landing Page
        </router-link>
      </div>
    </page-header>

    <div class="board-settings mt-2 pt-2 container">
      <div class="board-settings-box">
        <div class="title">Application Settings</div>
        <hr />

        <div class="row">
          <div class="col-4 col-sm-3 col-xl-2">
            <div class="flex-column board-settings-left">
              <router-link
                class="d-flex mb-3"
                :to="{
                  name: routes.users,
                }"
              >
                <i class="far fa-users fa-fw mr-2"></i>
                <div class="nav-item-title">Users</div>
              </router-link>

              <router-link
                class="d-flex"
                :to="{
                  name: routes.boardItemTemplates,
                }"
              >
                <i class="far fa-file-alt fa-fw mr-2"></i>
                <div class="nav-item-title">Templates</div>
              </router-link>
            </div>
          </div>

          <div class="col-8 col-sm-9 col-xl-10">
            <router-view></router-view>
          </div>

          <AppInfo />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import PageHeader from '@/components/PageHeader.vue';
  import { SettingsStore, SettingsModule } from '@/store/settings';
  import BoardSettings from '@/components/Board/BoardSettings.vue';
  import RouteNames from '@/types/routeNames';
  import { UserModule, UserStore } from '@/store/user';

  @Component({
    components: {
      PageHeader,
      BoardSettings,
    },
  })
  export default class ApplicationSettings extends Vue {
    private settings: SettingsModule = SettingsStore;
    private users: UserModule = UserStore;
    routes = RouteNames;

    mounted() {
      const hasRightsToSeePage = this.users.user && this.users.user.isAdmin;

      if (!hasRightsToSeePage) {
        this.$router.push({ name: 'Boards' });
      }
    }
  }
</script>
